import { Menu } from 'antd';
import { useTranslation } from 'react-i18next';
import { CurrentUser } from '@root/types';
import { useLocation } from 'react-router-dom';
import Breadcrumbs from '@components/shared/Breadcrumbs';
import Logo from './LogoWrapper';
import s from './Navigation.module.less';

type Props = {
  currentUser: CurrentUser;
};

const Navigation = ({ currentUser }: Props) => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <Menu
      theme="light"
      mode="horizontal"
      style={{ lineHeight: '64px' }}
      selectedKeys={[location.pathname]}
      className={s.navigation}
    >
      <Menu.Item className={s.staticLink}>
        <Logo />
      </Menu.Item>
      <Breadcrumbs />
      <div className={s.spacer} />
      <Menu.Item className={s.navigationLink} key="user-settings-link">
        <a href="/users/edit">{currentUser.email}</a>
      </Menu.Item>
      <Menu.Item className={s.navigationLink} key="sign-out-link">
        <a href="/users/sign_out">{t('navigation:signOut')}</a>
      </Menu.Item>
    </Menu>
  );
};

export default Navigation;
